import React from "react";
import { rem } from "polished";
import styled from "styled-components";

import { TooltipPopoverContainer } from "../../../../../containers/common";
import { FormInput } from "../../../atoms/form/form-input";
import { device } from '../../../../../utils';

const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: ${rem("40px")};
  padding: ${({ theme }) => `0 ${theme.spacing.size18}`};

  div[data-lastpass-icon-root] {
    display: none;
  }
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacing.size12};

  @media ${device.tablet} {
    margin-right: ${({ theme }) => theme.spacing.size22};
  }
`;

const TooltipPopoverContainerWrapper = styled.div`
  > div {
    top: 100%;
    white-space: nowrap;
    margin-top: ${({ theme }) => theme.spacing.size12};
  }
`;

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  isTooltipShown?: boolean;
  tooltipText?: string;
  isUppercase?: boolean;
}

export const FilterFieldInput = ({
  icon,
  isTooltipShown,
  tooltipText,
  isUppercase,
  ...props
}: Props): JSX.Element => (
  <InputContainer>
    {icon && <IconContainer>{icon}</IconContainer>}
    <FormInput {...props} isUppercase={isUppercase} />
    <TooltipPopoverContainerWrapper>
      <TooltipPopoverContainer
        isShow={Boolean(isTooltipShown)}
        text={tooltipText ?? ""}
      />
    </TooltipPopoverContainerWrapper>
  </InputContainer>
);
